<template>
  <section v-editable="cms" :class="[name]" :style="mainCssVars">
    <grid
      v-if="(cms.filter || []).length > 0"
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__filter-list`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 24 },
        ]"
      >
        <component
          :is="item.component"
          v-for="(item, index) in cms.filter"
          :key="index"
          v-editable="item"
          :cms="item"
          :class="`${name}__filter`"
          @onLatestFilterClick="onLatestFilterClick"
        />
      </grid-item>
    </grid>
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <fetch-story
          :route="cms.api_endpoint || 'en-gb/thinking'"
          :params="{
            sort_by: cms.api_order || null,
            by_uuids: cms.api_filter || null,
          }"
          :limit="parseInt(cms.api_limit) || 0"
          :offset="parseInt(cms.api_offset) || 0"
          :collection="cms.collection"
          entry="content"
        >
          <div slot-scope="{ loading, collection }" :class="[`${name}__cards`]">
            <div v-if="loading" :class="[`${name}__loader`]">
              <a-canvas-bars />
            </div>
            <template v-else>
              <div
                v-for="(item, index) in filteredCollection(collection)"
                :key="index"
              >
                <m-card-narrow
                  v-for="(thumb, t_index) in item.thumbnails"
                  :key="t_index"
                  :cms="thumb"
                  :published="item.first_published_at"
                  :url="item.url"
                  :class="[`${name}__card`]"
                />
              </div>
            </template>
          </div>
        </fetch-story>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import ACanvasBars from '@/components/atoms/a-canvas/a-canvas-bars'
import data from '~/components/organisms/o-list-news/o-list-news-v1.data'
import Colors from '~/mixins/colors'
import FetchStory from '~/components/shared/fetch-story'
import MFilterLatest from '~/components/molecules/m-filters/m-filter-latest'
import MCardNarrow from '~/components/molecules/m-cards/m-card-narrow'
export default {
  components: { FetchStory, ACanvasBars, MFilterLatest, MCardNarrow },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-list-news-v1',
      checkedItems: [],
    }
  },

  computed: {
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
        '--spacing-top': this.cms.spacing_top || '100px',
        '--spacing-bottom': this.cms.spacing_bottom || '100px',
      }
    },
  },
  methods: {
    async stopLoader() {
      this.loaded = true
      await this.$store.dispatch('loading/stopBusyState')
    },
    filteredCollection(collection) {
      if (!this.checkedItems.length) return collection
      return collection.filter((item) => this.checkedItems.includes(item.tags))
    },
    onLatestFilterClick(values) {
      this.checkedItems = values
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-list-news-v1 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: var(--spacing-top) 0 var(--spacing-bottom);

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }
  ::v-deep a {
    &:hover,
    &:active {
      color: var(--hover-color);
    }
  }
  ::v-deep .m-card-narrow .a-cta {
    &:hover,
    &:active {
      color: var(--text-color);
    }
  }

  &__loader {
    padding: 100px 0;
  }

  &__cards {
    position: relative;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
  }

  &__cards:hover ::v-deep .m-card-narrow:not(.over) {
    img {
      filter: grayscale(1);
    }
  }
}

@include media-breakpoint-up(md) {
  .o-list-news-v1 {
    &__cards {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}

@include media-breakpoint-up(lg) {
  .o-list-news-v1 {
    &__cards {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}

@include media-breakpoint-up(xl) {
  .o-list-news-v1 {
    &__cards {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
